import clsx from "clsx"
import { z } from "zod"

export const infoButtonSchema = z.object({
  component: z.literal("info-button"),
  image: z.string(),
  title: z.string(),
  subtitle: z.string(),
  left: z.boolean().default(false),
  button_text: z.string(),
  button_link: z.string().default("/chat"),
})

type InfoButtonProps = z.infer<typeof infoButtonSchema>

export default function InfoButton(props: InfoButtonProps) {
  const {
    image,
    title,
    subtitle,
    left,
    button_link,
    button_text,
  } = props

  return (
    <div className="flex w-full justify-center py-[60px]">
      <div
        className={clsx(
          left
            ? "desktop:flex-row"
            : "desktop:flex-row-reverse",
          "flex flex-col items-center desktop:w-[606px] desktop:justify-between",
        )}>
        <div className="flex flex-col items-center gap-[22px]">
          <h3
            className={clsx(
              "w-[232px] text-center text-[24px] font-700 text-color-black",
              "whitespace-pre-line desktop:w-[295px] desktop:text-start",
            )}>
            {title}
          </h3>

          <img
            className="h-[325px] w-[236px] rounded-[9px] desktop:hidden"
			alt="info icon"
            src={image}
          />

          <p
            className={clsx(
              "w-[343px] text-center text-[18px] font-400 text-blue-700",
              "desktop:w-[295px] desktop:text-start",
            )}>
            {subtitle}
          </p>

          <a
            href={button_link}
            className={clsx(
              "mt-[18px] flex items-center justify-center gap-[8px]",
              "h-[44px] w-full rounded-[12px] text-[16px] font-600 disabled:pointer-events-none",
              "bg-primary-500 text-color-white disabled:opacity-40",
              "select-none transition-colors hover:bg-primary-600",
            )}>
            {button_text}
          </a>
        </div>

        <img
          src={image}
          alt="image"
          className="hidden h-[325px] w-[236px] rounded-[7px] desktop:flex"
        />
      </div>
    </div>
  )
}
